import { ImageParams } from "./types/imageParams";

export const getImageParams = (file: File): Promise<ImageParams> =>
    new Promise((resolve) => {
        const src = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => resolve({ src, width: img.width, height: img.height });
        img.src = src;
    });
